import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { MatDialog, ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { RouteIndentDetailsComponent } from '../route-indent-details/route-indent-details.component';
import { GlobalService } from 'src/app/global.service';
import { RouteTraceAdjustComponent } from '../route-trace-adjust/route-trace-adjust.component';
import { NotClosedRouteListComponent } from '../not-closed-route-list/not-closed-route-list.component';
import { UserIsActiveService } from 'src/app/services/user-is-active.service';

@Component({
  selector: 'app-indent-dashboard',
  templateUrl: './indent-dashboard.component.html',
  styleUrls: ['./indent-dashboard.component.scss']
})
export class IndentDashboardComponent {
  sessions: any[] = [];
  overall_indent = {};
  route_wise_indent: any[] = [];
  product_names = [];
  selected_session_id: number = 1;
  selected_date = 'today';
  indent_prepared_route_ids = {};
  timer: any = null;
  route_datas_loaded = false;
  master_data_loaded = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  res_data: any = null;
  selected_index: any;
  selected_heading_index: any;
  business_data_route_wise: any = {};
  product_types: string[];
  booth_types: any;
  pdf: any;
  route_indent_dict: any = {};
  loading = false;
  business_with_orders: any = [];
  overall_indent_loading: boolean = false;
  indent_prepared: boolean = false;
  overall_indent_pdf: any;
  overall_indent_status = 1;
  temp_route_dict: any;
  temo_route_close_details: any;
  route_value = 50;
  employee_user_type_id: any;
  title: any;

  constructor(private http: HttpService, private dialog: MatDialog, private global: GlobalService, private userIsActiveService: UserIsActiveService) {
    // this.userIsActiveService.checkUserIsActive();
    this.getAllNeededData();
    this.title = this.global._active_display_name;

    this.http.getEmployeeUserType().subscribe((data) => {
      console.log(data);
      this.employee_user_type_id = data;
    }, (error) => {
      console.error(error);
    });
  }

  async getAllNeededData() {
    this.selected_date = 'tomorrow';
    await this.getSessions();
    // this.getOverallIndentData();
    // this.getIndentRouteWiseData();
    // this.getPreparedIndentRouteIds();
    // this.serveTempRouteDetails();
  }

  serveTempRouteDetails() {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };

    this.http.serveTempRouteDetails(data).subscribe((data) => {
      console.log(data);
      this.temp_route_dict = data;
    }, (error) => {
      console.error(error);
    });
  }

  openNotClosedRouteList(route_list) {
    const dialogRef = this.dialog.open(NotClosedRouteListComponent, {
      data: {
        'route_list': route_list,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  async sessionChanged() {
    this.res_data = null;
    // this.selected_session_id = session_id;
    this.getOverallIndentData();
    this.getIndentRouteWiseData();
    this.getPreparedIndentRouteIds();
    this.serveTempRouteDetails();
    clearTimeout(this.timer);
  }

  async dateChanged() {
    this.res_data = null;
    console.log(this.selected_date);
    this.sessionChanged();
    // this.selected_session_id = session_id;
    // this.getOverallIndentData(session_id);
    // this.getIndentRouteWiseData(session_id);
  }

  async getSessions() {
    await this.http.getSession().toPromise().then((sessions: []) => {
      this.route_datas_loaded = true;
      this.sessions = sessions;
    }).then((error) => {
      console.log(error);
    });
  }

  rePrepareClicked(route_id) {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date,
      'selected_route_id': route_id
    };
    this.http.rePrepareIndent(data).subscribe((data) => {
      console.log(data);
      this.indent_prepared_route_ids[route_id] = 1;
      this.temp_route_dict[route_id][data['temp_route_id']] = 1;
    }, (error) => {
      console.log(error);
    });
  }


  getOverallIndentData() {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };

    this.http.checkForOverallRouteClose(data).subscribe((data: number) => {
      console.log('data');
      this.overall_indent_status = data['status']
      console.log(data['route_ids']);
      this.indent_prepared_route_ids = data['route_trace']
      console.log(this.indent_prepared_route_ids);
    }, (error) => {
      console.error(error);
    });

    this.http.getOverallIndentData(data).subscribe((indent_data) => {
      console.log(indent_data);
      this.res_data = indent_data;
      this.overall_indent = indent_data['overall_data'];
      this.product_types = Object.keys(this.res_data['product_group_wise'])
      this.booth_types = Object.keys(indent_data['booth_types'])
      const product_names_ids = Object.keys(indent_data['overall_data']['products']);
      product_names_ids.forEach(element => {
        this.product_names.push(indent_data['overall_data']['products'][element]['name'])
      });
      console.log(this.product_names);
      this.master_data_loaded = true;
    }, (error) => {
      console.log(error);
    });
  }

  radioChecked() {
    console.log(event);
  }

  calculate_percent(ordered, all) {
    let a = (ordered / all) * 100;
    return a.toFixed(2);
  }


  totalValue(icustomer_value = null, booth_value = null) {
    if (icustomer_value == null) {
      icustomer_value = 0;
    }
    if (booth_value == null) {
      booth_value = 0;
    }
    return icustomer_value + booth_value;
  }

  getSumDisplay(sum) {
    if (sum === null) {
      return 0;
    } else if (sum === 0) {
      return 0;
    } else {
      return sum;
    }
  }

  getBusinessList(route, index) {
    console.log(route);
    this.onPageTitleSelected(index);
    if (!this.business_data_route_wise.hasOwnProperty(route.route_id)) {
      const data_dict = {
        'route_id': route.route_id,
        'session_id': this.selected_session_id,
        'date': this.selected_date
      };
      this.http.getIntentForBusinessWise(data_dict).subscribe((data) => {
        console.log(data);
        this.business_data_route_wise[route.route_id] = data;
      }, (error) => {
        console.error(error);
      });
    }
  }

  getIndentRouteWiseData() {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };
    this.route_datas_loaded = false;
    this.http.getIndentRouteWiseData(data).subscribe((res_data: []) => {
      console.log(res_data);
      res_data.forEach((element) => {
        this.route_indent_dict[element['route_id']] = { 'is_loading': false };
        if (element['order_business_count'] !== 0) {
          this.business_with_orders.push(element['route_id'])
        }
      });
      console.log(this.business_with_orders);
      this.route_wise_indent = res_data;
      this.route_datas_loaded = true;
      this.calculate();
      console.log(this.route_indent_dict);
    }, (error) => {
      console.log(error);
      this.route_wise_indent = [];
      this.route_datas_loaded = true;
    });
  }

  prepareRouteIndent(route_id) {
    console.log(this.indent_prepared_route_ids);
    const data = {
      session_id: this.selected_session_id,
      route_id: route_id,
      date: this.selected_date
    };
    this.loading = true;
    this.http.prepareRouteIndent(data).subscribe((res_data) => {
      console.log(res_data);
      this.loading = false;
      if (res_data['tray_capasity_status']) {
        this.openRouteAdjustDialog(route_id);
      } else {
        // this.sessionChanged(this.selected_session_id);
        this.global.showSnakeBar('Indent Closed successfully! please wait for indent preparation');
        this.overall_indent['closed_route_count'] = this.overall_indent['closed_route_count'] + 1
        console.log(this.indent_prepared_route_ids);
        this.getGatePass(this.selected_date, route_id, this.selected_session_id, 'main');
      }
    }, (error) => {
      this.loading = false;
      console.log(error);
      alert(error['error']['error_message']);
    });
  }

  openRouteAdjustDialog(route_id) {
    console.log('dialog open');

    const dialogRef = this.dialog.open(RouteTraceAdjustComponent, {
      height: '720px',
      width: '860px',
      data: {
        'route_id': route_id,
        'date': this.selected_date,
        'session_id': this.selected_session_id
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if (res !== null) {
        this.temo_route_close_details = res['data'];
        if (this.temo_route_close_details['main_route']['is_closed']) {
          this.overall_indent['closed_route_count'] = this.overall_indent['closed_route_count'] + 1;
          await this.getGatePass(this.selected_date, this.temo_route_close_details['main_route']['route_id'], this.selected_session_id, 'main').then(() => {
            if (this.temo_route_close_details['temp_route']['is_closed']) {
              this.overall_indent['closed_route_count'] = this.overall_indent['closed_route_count'] + 1
              this.getGatePass(this.selected_date, this.temo_route_close_details['temp_route']['route_id'], this.selected_session_id, 'temp');
              console.log('tee called')
            }
          });
        }

        // this.updateDiscountPrice(res);
      }
    });
  }

  async getGatePass(date, route_id, session_id, which_route) {
    console.log(which_route)
    const req_data = {
      'date': date,
      'route_id': route_id,
      'session_id': session_id,
      'which_route': which_route
    };
    if (which_route === 'main') {
      this.route_indent_dict[route_id]['is_loading'] = true;
    }
    await this.http.PrepareCanvas(req_data).toPromise().then((data) => {
      console.log(data);
      if (which_route === 'main') {
        this.route_indent_dict[route_id]['pdf'] = data['pdf'];
        this.route_indent_dict[route_id]['status'] = 3;
        this.route_indent_dict[route_id]['is_loading'] = false;
        this.indent_prepared_route_ids[route_id] = {};
        this.indent_prepared_route_ids[route_id] = 3;
      }
      if (which_route === 'temp') {
        this.temp_route_dict[this.temo_route_close_details['main_route']['route_id']][route_id] = 3;
      }
      console.log(this.temp_route_dict);
      this.global.showSnakeBar('indent prepared success');
      console.log(this.indent_prepared_route_ids);
    }).then((error) => {
      this.route_indent_dict[route_id]['is_loading'] = false;
      console.log(error);
    });
  }

  showPdf(route_id) {
    console.log('pdf is not locally');
    const data = {
      session_id: this.selected_session_id,
      route_id: route_id,
      date: this.selected_date
    };
    this.http.getIndentPdf(data).subscribe((data) => {
      console.log(data)
      // this.route_indent_dict[route_id]['pdf'] = data['pdf']
      this.indent_prepared_route_ids[route_id] = 3;
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      let session_name = 'Morning';
      if (this.selected_session_id === 2) {
        session_name = 'Evening';
      }
      const fileName = route_id + '_' + this.selected_date + '-' + session_name + ".pdf";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    });

  }

  closeOverallIndent() {
    const data = {
      session_id: this.selected_session_id,
      date: this.selected_date,
      business_with_orders: this.business_with_orders
    };
    this.overall_indent_loading = true;
    this.http.closeOverallIntent(data).subscribe((data: any) => {
      console.log(data);
      if (data.length !== 0) {
        this.openNotClosedRouteList(data);
      } else {
        this.global.showSnakeBar('All Routes closed successfully!');
      }
      this.sessionChanged();
      this.overall_indent_loading = false;
    }, (error) => {
      this.overall_indent_loading = false;
      console.error(error);
    });
  }

  prepareOverallIndent() {
    const data = {
      session_id: this.selected_session_id,
      date: this.selected_date,
      business_with_orders: this.business_with_orders
    };
    this.overall_indent_loading = true;
    this.http.prepareIndentForAllClosedRoutes(data).subscribe((data) => {
      if (data === false) {
        if (confirm("Some routes are not closed ! Do you want to close all routes")) {
          this.closeOverallIndent();
          return false;
        }
      }
      console.log(data);
      this.overall_indent_pdf = data;
      // this.overall_indent_loading = true;
      this.indent_prepared = true;
      this.sessionChanged();
      this.global.showSnakeBar('Overall Indent prepared successfully!');
      this.overall_indent_loading = false;
    }, (error) => {
      this.overall_indent_loading = false;
      console.error(error);
    });
  }

  downloadOverallIndent() {
    if (this.overall_indent_pdf == null) {
      const data_dict = {
        session_id: this.selected_session_id,
        date: this.selected_date
      };
      this.http.getOverallPdf(data_dict).subscribe((data) => {
        this.overall_indent_pdf = data;
        const linkSource = 'data:application/pdf;base64,' + data;
        const downloadLink = document.createElement("a");
        let session_name = 'Morning';
        if (this.selected_session_id === 2) {
          session_name = 'Evening';
        }
        const fileName = 'overall' + '_' + this.selected_date + '-' + session_name + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      return false;
    }
    const linkSource = 'data:application/pdf;base64,' + this.overall_indent_pdf;
    const downloadLink = document.createElement("a");
    let session_name = 'Morning';
    if (this.selected_session_id === 2) {
      session_name = 'Evening';
    }
    const fileName = 'Overall' + '_' + this.selected_date + '-' + session_name + ".pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getPreparedIndentRouteIds() {
    // const data = {
    //   date: this.selected_date,
    //   session_id: this.selected_session_id
    // };
    // this.http.getPreparedIndentRouteIds(data).subscribe((res_data: number[]) => {
    //   console.log(res_data);
    //   this.indent_prepared_route_ids = res_data['indent_prepared_route_ids'];
    // }, (error) => {
    //   console.log(error);
    // });
  }

  showIndentDetails(route_id) {
    console.log(route_id);
    this.dialog.open(RouteIndentDetailsComponent, {
      position: {
        top: '0px',
        right: '0px'
      },
      height: '100%',
      width: '100vw',
      data: {
        'route_id': route_id,
        'session_id': this.selected_session_id,
        'date': this.selected_date
      },
    });
  }

  downloadIndent(route_id) {

  }

  isIndentPrepard(route_id) {
    // return (this.indent_prepared_route_ids.indexOf(route_id) > -1);
  }

  calculate() {
    this.timer = setInterval(() => {
      for (let i in this.route_wise_indent) {
        // console.log(this.route_wise_indent[i]['order_expiry_time']);
        const expiry_date_time = new Date(this.route_wise_indent[i]['order_expiry_time'])
        const time_diff = expiry_date_time.getTime() - new Date().getTime();
        this.route_wise_indent[i]['time_diff'] = time_diff;
      }
    }, 1000);
    // setInterval(() => {

    //   // console.log(expiry_time);
    //   const ex_time = new Date(expiry_time);
    //   const time_diff = ex_time.getTime() - new Date().getTime();
    //   // this.route_wise_indent[index]['order_expiry_time'] = time_diff;
    //   // console.log(time_diff);
    //   return time_diff;
    // }, 1000);
  }

  ngOnDestroy() {
    console.log('destroy');
    clearTimeout(this.timer);
  }

  onPageTitleSelected(index) {
    if (this.selected_index === index) {
      this.selected_index = null;
    } else {
      this.selected_index = index;
    }
    this.selected_heading_index = null;
  }

}

